import { simple } from 'src/utils/reducers';
import * as documents from './reducers/documents';

// eslint-disable-next-line import/no-default-export
export default simple({
    REPORTING_GET_DOCUMENT: documents.request,
    REPORTING_FINISH_DOCUMENT: documents.finish,
    REPORTING_ERROR_DOCUMENT: documents.error,
});
